import api from './API';

import UtilityFunction from '../Util/Util';

const { responseFormat } = UtilityFunction;

const basePath = 'straw';
const pathList = {
    strawsList: `/`,
};

for(let key in pathList) {
    pathList[key] = basePath + pathList[key];
}

const strawsList = async () => {
    try {
        const apiPath = pathList.strawsList;
        const addons = await api.getCall(apiPath);
        
        return addons;
    } catch(e) {
        console.log(e.toString());
    
        return responseFormat(-1, "Failed to get straws!");
    }
};

const strawAPI = {
    strawsList,
}

export default strawAPI;